export class Peer<T = number, U = string> {
    key: T;
    value: U;

    constructor(key: T, value: U) {
        this.key = key;
        this.value = value;
    }
}
